import { SackDollarSolid } from '@allocab/allocab-icons';
import { Helmet } from 'react-helmet-async';

import { TapToPaySection } from './_authenticated._main.settings/TapToPaySection';
import { SwitchSelectButton, SwitchSelectItem } from '../components/button/SwitchSelectButton';
import { DriverOptionOutput } from '../hooks/types';
import usePatchDriverOptions from '../hooks/usePatchDriverOptions';
import { useDriverOptions } from '../services/driver-options/useDriverOptions';
import { t } from '../services/translation/translation';

const commissionItems: SwitchSelectItem<DriverOptionOutput['seePriceWithCommission']>[] = [
  { value: true, render: () => <span>{t('settings-route.with-commission')}</span> },
  { value: false, render: () => <span>{t('settings-route.without-commission')}</span> },
];

export const SettingsRoute = () => {
  const { driverOptions } = useDriverOptions();
  const { mutate: patchDriverOptions } = usePatchDriverOptions();

  return (
    <div className="max-w-screen-md m-auto">
      <Helmet>
        <title>{t('settings-route.title')} - Allocab</title>
      </Helmet>
      <h3 className="text-3xl font-bold dark:text-white mb-6">{t('settings-route.title')}</h3>
      <div className="space-y-4">
        <div className="space-y-2">
          <h6 className="text-lg font-bold dark:text-white flex items-center gap-2">
            <SackDollarSolid width={16} height={16} className="fill-current" />
            {t('settings-route.price-title')}
          </h6>
          <SwitchSelectButton
            items={commissionItems}
            value={driverOptions.seePriceWithCommission}
            onValueChange={seePriceWithCommission => patchDriverOptions({ seePriceWithCommission })}
          />
        </div>
        <TapToPaySection />
      </div>
    </div>
  );
};
